import _ from 'lodash'
import store from '@/store'
import { GlobalState, UiLanguageItem } from '@/types'
import { DepartmentEmployeeResponse, DepartmentEmployeeResponseItem } from '@/types/service-response'
import moment from 'moment'

export class CompanyEmployee {
  public constructor (
    readonly id: number,
    readonly personalNumber: string,
    readonly departmentId: number,
    readonly profitCenterId: number,
    readonly planningGroupId: number | null,
    readonly isPlanable: boolean,
    readonly isFloater: boolean,
    readonly position: string,
    readonly salutation: string,
    readonly status: number | null,
    readonly statusDescription: string,
    readonly givenName: string,
    readonly familyName: string,
    readonly nickName: string,
    readonly fullName: string,
    readonly shortName: string,
    readonly birthDate: string | undefined,
    readonly placeOfResidence: string | undefined,
    readonly replacementOfEmployeeId: number | null,
    readonly preferredLanguageId: number,
    readonly workplace: string,
    readonly entryDate: string | undefined,
    readonly exitDate: string | undefined,
    readonly supervisorId: number | null,
    readonly photo: string | undefined,
    readonly levelOfEmployment: number | null,
    readonly email: string | undefined,
    readonly businessEmail: string | undefined,
    readonly phone: string | undefined,
    readonly mobilePhone: string | undefined,
    readonly floaterDepartments: Array<number>,
    readonly isApprentice: boolean,
    readonly schoolIn : any | undefined,
    readonly phonePlus: string,
    readonly skype: string,
    readonly nationality: string,
    readonly SYZInTimeAktiv: boolean,
    readonly anmeldungen: number | null,
    readonly privatAdresse: number | null,
    readonly druckgruppe: number | null,
    readonly passwordFrom: string | undefined,
    readonly passwordTo: string | undefined
  ) {}

  public get preferredLanguage (): UiLanguageItem | undefined {
    const state: GlobalState = store.state

    return _.find(state.uiLanguageList, { syzId: this.preferredLanguageId })
  }

  public get photoUrl (): string {
    return this.photo && `/img/${this.photo}` || ''
  }

  public get fakeEmail (): string {
    return _.deburr(`${this.givenName}.${this.familyName}@syzag.ch`).toLocaleLowerCase()
  }

  public get fakePhone (): string {
    const numbers = [
      '+41',
      '78',
      _.random(150, 930).toString(),
      _.random(20, 99).toString(),
      _.random(20, 99).toString(),
    ]

    return numbers.join(' ')
  }

  static createListFromDepartmentEmplyeeListResponse (data: DepartmentEmployeeResponse): Array<CompanyEmployee> {
    return data.map((item: DepartmentEmployeeResponseItem) => {
      const birthDate = item.Geburtsdatum ? moment(item.Geburtsdatum,'DD.MM.YYYY HH:mm:ss').format('YYYY-MM-DD') : undefined
      const exitDate = item.AustrittDatum ? moment(item.AustrittDatum,'DD.MM.YYYY HH:mm:ss').format('YYYY-MM-DD') : undefined
      const entryDate = item.EintrittDatum ? moment(item.EintrittDatum,'DD.MM.YYYY HH:mm:ss').format('YYYY-MM-DD') : undefined
      const passwordFrom = item.PasswortVon ? moment(item.PasswortVon,'DD.MM.YYYY HH:mm:ss').format('YYYY-MM-DD') : undefined
      const passwordTo = item.PasswortBis ? moment(item.PasswortBis,'DD.MM.YYYY HH:mm:ss').format('YYYY-MM-DD') : undefined

      return new CompanyEmployee(
        item.ID,
        item.PersonalNummer ? item.PersonalNummer : '',
        item.Abteilung,
        item.ProfitCenter,
        item.PlanungsgruppeID,
        item.PlanBar ? item.PlanBar : false,
        item.springer ? item.springer : false,
        item.Stellung ? item.Stellung : '',
        item.Anrede ? item.Anrede : '',
        item.Status,
        item.StatusDescription ? item.StatusDescription : '',
        item.Vorname ? item.Vorname : '',
        item.Name ? item.Name : '',
        item.Nickname ? item.Nickname : '',
        item.VollerName ? item.VollerName : '',
        item.Kurzzeichen ? item.Kurzzeichen : '',
        birthDate,
        item.Wohnort ? item.Wohnort : '',
        item.Stellvertretung,
        item.UISprache,
        item.Arbeitsort ? item.Arbeitsort : '',
        entryDate,
        exitDate,
        item.Vorgesetzter,
        item.Photo,
        item.BG ? item.BG : null,
        item.Email ? item.Email : undefined,
        item.MailGeschaft ? item.MailGeschaft : undefined,
        item.Phone ? item.Phone : undefined,
        item.MobilePhone ? item.MobilePhone : undefined,
        item.springerAbteilungs,
        item.Lernender ? item.Lernender : false,
        item.SchuleIn ? item.SchuleIn : undefined,
        item.Privat2 ? item.Privat2 : '',
        item.Zusatz ? item.Zusatz : '',
        item.Nationality ? item.Nationality : '',
        item.SYZInTimeAktiv ? item.SYZInTimeAktiv : false,
        item.Anmeldungen,
        item.PrivatAdresse,
        item.Druckgruppe,
        passwordFrom,
        passwordTo
      )
    })
  }

  static createFromEmplyeeFromResponse (item: DepartmentEmployeeResponseItem): CompanyEmployee {
    const birthDate = item.Geburtsdatum ? moment(item.Geburtsdatum,'DD.MM.YYYY HH:mm:ss').format('YYYY-MM-DD') : undefined
    const exitDate = item.AustrittDatum ? moment(item.AustrittDatum,'DD.MM.YYYY HH:mm:ss').format('YYYY-MM-DD') : undefined
    const entryDate = item.EintrittDatum ? moment(item.EintrittDatum,'DD.MM.YYYY HH:mm:ss').format('YYYY-MM-DD') : undefined
    const passwordFrom = item.PasswortVon ? moment(item.PasswortVon,'DD.MM.YYYY HH:mm:ss').format('YYYY-MM-DD') : undefined
    const passwordTo = item.PasswortBis ? moment(item.PasswortBis,'DD.MM.YYYY HH:mm:ss').format('YYYY-MM-DD') : undefined

    return new CompanyEmployee(
      item.ID,
      item.PersonalNummer ? item.PersonalNummer : '',
      item.Abteilung,
      item.ProfitCenter,
      item.PlanungsgruppeID,
      item.PlanBar ? item.PlanBar : false,
      item.springer ? item.springer : false,
      item.Stellung ? item.Stellung : '',
      item.Anrede ? item.Anrede : '',
      item.Status,
      item.StatusDescription ? item.StatusDescription : '',
      item.Vorname ? item.Vorname : '',
      item.Name ? item.Name : '',
      item.Nickname ? item.Nickname : '',
      item.VollerName ? item.VollerName : '',
      item.Kurzzeichen ? item.Kurzzeichen : '',
      birthDate,
      item.Wohnort ? item.Wohnort : '',
      item.Stellvertretung,
      item.UISprache,
      item.Arbeitsort ? item.Arbeitsort : '',
      entryDate,
      exitDate,
      item.Vorgesetzter,
      item.Photo,
      item.BG ? item.BG : null,
      item.Email ? item.Email : undefined,
      item.MailGeschaft ? item.MailGeschaft : undefined,
      item.Phone ? item.Phone : undefined,
      item.MobilePhone ? item.MobilePhone : undefined,
      item.springerAbteilungs,
      item.Lernender ? item.Lernender : false,
      item.SchuleIn ? item.SchuleIn : undefined,
      item.Privat2 ? item.Privat2 : '',
      item.Zusatz ? item.Zusatz : '',
      item.Nationality ? item.Nationality : '',
      item.SYZInTimeAktiv ? item.SYZInTimeAktiv : false,
      item.Anmeldungen,
      item.PrivatAdresse,
      item.Druckgruppe,
      passwordFrom,
      passwordTo
    )
  }
}
